export default __webpack_public_path__ + "static/media/gg4.1c65984a.jpeg";